import React from 'react'
import { AiIcon } from '@diversioteam/diversio-ds'

import * as S from './lumi.styles'

export const LumiNavContent = () => {
    return (
        <S.LumiNavContentWrapper>
            <S.Text>Transform job posts to attract top talent.</S.Text>

            <S.ActionText>Try Lumi Today</S.ActionText>

            <S.IconWrapper>
                <AiIcon type="bold" color="#7961FF" />
            </S.IconWrapper>
        </S.LumiNavContentWrapper>
    )
}
